<div class="control-line mat-elevation-z8">
  <div class="filter-actions-line">
    <!-- months-select.component.html -->
    <mat-form-field appearance="outline">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
        <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
        <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <button id="toteinvbtn" data-testid="toteinvbtn" mat-raised-button color="primary" (click)="ORAOutboundSearch()">
      Search
    </button>
    @if(controlPermissions.addButton){
      <button id="toteinvbtn" data-testid="toteinvbtn" mat-raised-button
              color="primary" (click)="AddorEditORAOutbound(null, 'Add')">
        Add Entry
      </button>
    }
  </div>
</div>
<div class="gridheight mat-elevation-z8 viewport">
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <div>
          <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="AddorEditORAOutbound(element, 'Edit')">
            <mat-icon>edit</mat-icon>
          </button>
          @if(controlPermissions.delete){
            <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDelete(element)" style="color: red;">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </td>
    </ng-container>
    <!-- Work Order Number Column -->
    <ng-container matColumnDef="captureDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
      <td mat-cell *matCellDef="let element"> {{element.captureDate | date: 'MM/dd/yyyy'}} </td>
    </ng-container>
    <!-- Reprocess Column -->
    <ng-container matColumnDef="revenueTypeName">
      <th mat-header-cell *matHeaderCellDef> Revenue Type </th>
      <td mat-cell *matCellDef="let element">
        {{element.revenueTypeName}}
      </td>
    </ng-container>
    <!-- Status Code Column -->
    <ng-container matColumnDef="numberofHauls">
      <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center !important;"> # Hauls </th>
      <td mat-cell *matCellDef="let element"> {{element.numberofHauls}} </td>
    </ng-container>
    <ng-container matColumnDef="totalTons">
      <th mat-header-cell *matHeaderCellDef>Total Tons</th>
      <td mat-cell *matCellDef="let element">
        {{element.totalTons}}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- No Data Row -->
    <tr class="mat-row hover:bg-transparent" *matNoDataRow>
      <td class="mat-cell text-center text-gray-500 py-4" [attr.colspan]="displayedColumns.length"
          style="color: red;text-align: center;font-weight: 500;">
        No data found.
      </td>
    </tr>
  </table>
</div>